import React, { useEffect, useState, useRef } from "react";
import { axiosApi, preFilter, newColumns } from "./utils";
import { getCNVSummary } from "./utils/getCNVSummary";
import { dataMapper } from "./utils/dataMapper";
import TableComponentForVariants from "./TableComponentForVariants";
import { useDispatch,
 // useSelector
} from "react-redux";
import useViewFeatures from "./hooks/useViewFeatures";
import { setTable } from "./store/slices/tables/table.slice";
import {somatic_query_default} from "../../../scenes/dashboard/components/genomics-dashboard/components/results/components/variant-table/gpap-table/somatic_table/somatic_query_default";
import LoadingDataComponent from "./LoadingDataComponent";
import { tagged_variants_request } from "../../../services/api/variants_api";

function CustomTableForCNVs({
  url, method,
  total,
  dataType,
  locationData = false,
  dataHeader = [],
  token,
  configFilter,
  nestedInfo = [],
  nestedInfoB = [],
  split = [],
  compactColumns,
  compactColumnsSplit,
  tooltipCompact,
  tooltipCompactSplit,
  customFeatures,
  chipFull = [],
  buttons,
  type = "expanding",
  queryID,
  setLoading,
  loadingData,
  experiment, genes, freqInt, clinvar, acmg,
  getTotal,
  setSelected,
  shouldFetchCNV = true,
  isSearchAcross = false,
  //getAllTaggedVariants,
  //all_tagged_variants,
  isSNVSelected,
}) {
  const [data, setData] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [dataButton, setDataButton] = useState([]);
  const [isCheck, setIsCheck] = useState(false);
  const [open, setOpen] = useState(false);
  const [rowIdSelected, setRowIdSelected] = useState(null);
  const [render, setRender] = useState(<h1>Test</h1>);
  const [resApi, setResApi] = useState([]);
  const [idExpanded, setIdExpanded] = useState({
    id: null,
    isExpanded: false,
  });
  const [testExpand, setTestExpand] = useState({});
  const [isOpenPopover, setIsOpenPopover] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [genesArray, setGenes] = useState(["bootstrap"]);
  const prevQueryParamsRef = useRef({});
  const dispatch = useDispatch();


  // store gene names of the table
  const [geneNames, setGeneNames] = useState([]);
  // store tagged CNV variants...
  const [all_tagged_variants, setTaggedVariants] = useState([]);
 
  
  useEffect(function(){
  
      getAllTaggedVariants();
  
  
  }, [geneNames]);
  
  
  
  const getAllTaggedVariants = () => {   
      
      tagged_variants_request(config.apis_configuration.api_phenostore, token, {genes: geneNames})
                      .then(r => r.json())
                      .then(function(json){ 
                          // process ...
                          if("data" in json){
                            setTaggedVariants(json.data);
                          }
                      });
      }



  const states = {
    mainData,
    customFeatures,
    setMainData,
    data,
    resApi,
    isCheck,
    setIsCheck,
    open,
    setOpen,
    render,
    setRender,
    idExpanded,
    setIdExpanded,
    isOpenPopover,
    setIsOpenPopover,
    dataButton,
    setDataButton,
    testExpand,
    setTestExpand,
    rowIdSelected,
    setRowIdSelected,
    dataFilter,
    setDataFilter,
    setSelected,
    getAllTaggedVariants,
    all_tagged_variants,
  };

  useEffect(() => {
    dispatch(
      setTable({
        option: "allState",
        value: { mainData, data, customFeatures },
      })
    );
  }, [dispatch]);

  const renderFeatures = useViewFeatures(states, customFeatures);

  useEffect(() => {
    if (dataType === "CNV" && !shouldFetchCNV) {
      setData([]);
      setMainData([]);
      //setLoading(false);
      return;
    }

    let body;

    if(dataType === "somatic"){

      body = JSON.parse(JSON.stringify(somatic_query_default));

      // here update experiment id...


    }
    else{

      // CNV Body request
      const filtered = [{"id":"Experiment_ID", "value": experiment}];
      //if (isSearchAcross) {
      //  filtered.push({"id":"Annotation_mode", "value": ["full"]});
      //}
      body = {
        "page":1,
        "pageSize":10000,
        "fields": [],
        "sorted":[],
        "filtered": filtered
      }

      if (Array.isArray(genes) && genes.length > 0){
        body["filtered"].push({"id": "Gene_name", "value": genes});

      }

      // Map freqInt to Internal_Freq for CNV filtering
      // Only add filter if freqInt is a valid number (not null, undefined, empty string, or NaN)
      if (freqInt !== null && freqInt !== undefined && freqInt !== "" && !isNaN(parseFloat(freqInt)) && isFinite(freqInt)){
        body["filtered"].push({"id": "Internal_Freq", "value": [parseFloat(freqInt)], "operator": "lte"});
      }

      // Map clinvar filter to clinvar_clnsig for CNV filtering
      // UI filter options mapping:
      // - Pathogenic (P) → "P"
      // - Likely Pathogenic (L) → "LP"
      // - Variant of uncertain significance (U) → "VUS"
      // - Conflicting interpretations (C) → "C"
      // - Drug response (D) → "Drug"
      // - Any (A) → all CNV options NOT already mapped: ["LB", "B", "Other"]
      if (clinvar !== null && clinvar !== undefined && typeof clinvar === 'object'){
        const valueMapping = {
          "P": "P",      // Pathogenic → P
          "L": "LP",     // Likely Pathogenic → LP
          "U": "VUS",    // Variant of uncertain significance → VUS
          "C": "C",      // Conflicting interpretations → C
          "D": "Drug",   // Drug response → Drug
        };
        
        // Options that are directly mapped from UI filters
        const mappedOptions = ["P", "LP", "VUS", "C", "Drug"];
        
        // All CNV ClinVar options (excluding NA)
        const allCNVClinvarOptions = ["P", "LP", "VUS", "C", "LB", "B", "Drug", "Other"];
        
        // "Any" maps to all options EXCEPT the ones already mapped
        const anyClinvarOptions = allCNVClinvarOptions.filter(opt => !mappedOptions.includes(opt));
        // Result: ["LB", "B", "Other"]
        
        const selectedClinvar = Object.keys(clinvar)
          .filter(key => clinvar[key] === true)
          .flatMap(key => {
            if (key === "A") {
              // Map "Any" to options NOT already mapped
              return anyClinvarOptions;
            } else {
              // Use mapping or original value if not in mapping
              return valueMapping[key] || key;
            }
          });
        
        // Remove duplicates in case "A" is selected along with other options
        const uniqueSelectedClinvar = [...new Set(selectedClinvar)];
        
        if (uniqueSelectedClinvar.length > 0){
          body["filtered"].push({"id": "clinvar_clnsig", "value": uniqueSelectedClinvar});
        }
      }

      // Map ACMG_class filter (using InterVar values from SNV filter panel)
      // InterVar values mapping to ACMG_class:
      // - B (Benign) → "Benign"
      // - LB (Likely Benign) → "Likely benign"
      // - P (Pathogenic) → "Pathogenic"
      // - LP (Likely Pathogenic) → "Likely pathogenic"
      // - VUS (Variant of Uncertain Significance) → "Uncertain significance"
      if (acmg !== null && acmg !== undefined && typeof acmg === 'object'){
        const acmgValueMapping = {
          "B": "Benign",                    // Benign → Benign
          "LB": "Likely benign",            // Likely Benign → Likely benign
          "P": "Pathogenic",                // Pathogenic → Pathogenic
          "LP": "Likely pathogenic",        // Likely Pathogenic → Likely pathogenic
          "VUS": "Uncertain significance"   // VUS → Uncertain significance
        };
        
        const selectedACMG = Object.keys(acmg)
          .filter(key => acmg[key] === true)
          .map(key => acmgValueMapping[key] || key); // Use mapping or original value if not in mapping
        
        // Remove duplicates in case multiple InterVar values map to the same ACMG class
        const uniqueSelectedACMG = [...new Set(selectedACMG)];
        
        if (uniqueSelectedACMG.length > 0){
          body["filtered"].push({"id": "ACMG_class", "value": uniqueSelectedACMG});
        }
      }
    }

    setGenes(genes);
    
    // Trigger CNV query when: queryID changes, first init, gene selection changes, or experiment list changes (e.g. "Show Participant Variants")
    const prev = prevQueryParamsRef.current;
    const queryIDChanged = prev.queryID !== queryID;
    const genesChanged = prev.genes === undefined || JSON.stringify(prev.genes) !== JSON.stringify(genes);
    const experimentChanged = prev.experiment === undefined || JSON.stringify(prev.experiment) !== JSON.stringify(experiment);
    // In search-across/cohort mode, any gene-selection change (including switching to "All", i.e. empty list)
    // should refetch. In the normal case the gene list comes from the live filter panel, so we must NOT refetch
    // on gene changes there (only on "Run query" / queryID change).
    const geneSelectedForData = shouldFetchCNV && isSearchAcross && genesChanged;
    const experimentChangedForParticipant = shouldFetchCNV && Array.isArray(genes) && genes.length > 0 && experimentChanged;

    if (queryIDChanged || !initialized || geneSelectedForData || experimentChangedForParticipant) {
      setInitialized(true);
      prevQueryParamsRef.current = { queryID, genes, experiment };

      const options = {
        url,
        method,
        token,
        isCheck,
        locationData,
        split,
        dataHeader,
        nestedInfo,
        nestedInfoB,
        setData,
        setMainData,
        setResApi,
        body,
        getTotal,
        dataType,
        setLoading,
        setGeneNames
      };

      axiosApi(options);
    }

  }, [queryID, freqInt, experiment, genes, clinvar, acmg, shouldFetchCNV]);


  useEffect(() => {

    // at the moment of creating a new query, "Run Query", take predfined gene list and get data from server

    // filter with gene list updated

  }, [] )

  const nestedColumns = isCheck
    ? nestedInfoB.map((item) => {
        return {
          Header: item.nameColumn,
          accessor: item.dataSearch,
          tooltip: item.tooltip
        };
      })
    : nestedInfo.map((item) => {
        return {
          Header: item.nameColumn,
          accessor: item.dataSearch,
          tooltip: item.tooltip
        };
      });

  const selectArray = isCheck ? split : dataHeader;

  const [preFilteredData, setPreFilteredData] = useState([]);

  useEffect(() => {
    if (configFilter) {
      return preFilter(
        mainData,
        isCheck,
        configFilter,
        compactColumns,
        compactColumnsSplit,
        setPreFilteredData,
        setDataFilter
      );
    }

    setPreFilteredData(mainData);
  }, [mainData, isCheck, configFilter]);

  useEffect(() => {
    let initialExpandState = {};

    preFilteredData.forEach((item, index) => {
      initialExpandState[index] = false;
    });

    setTestExpand(initialExpandState);
  }, [preFilteredData]);


  const columns = React.useMemo(
    () =>
      newColumns(
        selectArray,
        configFilter,
        isCheck,
        preFilteredData,
        compactColumns,
        compactColumnsSplit,
        tooltipCompact,
        tooltipCompactSplit
      ),
    [isCheck]
  );

  return (
      <>
        {(loadingData)
            ?   <LoadingDataComponent/>
            :  <TableComponentForVariants
                columns={columns}
                data={ preFilteredData}
                dataAnidada={preFilteredData}
                type={type}
                nestedColumns={nestedColumns}
                buttons={buttons}
                states={states}
                renderFeatures={renderFeatures}
                tooltipCompact={tooltipCompact}
                chipFull={chipFull}
                total={total}
                isSNVSelected = {isSNVSelected}
            />

        }
      </>
  );
}

export default CustomTableForCNVs;
